import React, { FC, useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Copyright from "../../components/Copyright";
import { useForm, SubmitHandler } from "react-hook-form";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import { Error } from "@material-ui/icons";
import LoadingButton from "../../components/buttons/LoadingButton";
import { useHistory } from "react-router-dom";
import * as auth from "../../api/auth";
import NoDataDialog from "../../components/dialogs/ErrorDialog";
import { TokenStorage } from "../../api/auth/TokenStorage";

const iconPath = process.env.PUBLIC_URL + "/assets/";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    height: "100vh",
  },
  image: {
    backgroundImage: `url(${iconPath}device.jpg)`,
    backgroundRepeat: "no-repeat",
    backgroundColor:
      theme.palette.type === "light"
        ? theme.palette.grey[50]
        : theme.palette.grey[900],
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
}));

type FormValues = {
  username: string;
  password: string;
};

const Login: FC = () => {
  const classes = useStyles();
  const { register, handleSubmit, errors } = useForm<FormValues>();
  const history = useHistory();
  const [error, setError] = useState("");
  const [pending, setPending] = useState(false);
  const [resetPassword, setResetPassword] = useState(false);
  const [open, setOpen] = useState(!!process.env.REACT_APP_TEST_BUILD);
  //const [checked, setChecked] = useState(false);
  useEffect(() => {
    const checkAuth = async () => {
      if (await auth.isAuth()) {
        history.push("/mobilbase/plads");
      }
    };
    checkAuth();
  });

  useEffect(() => {
    if (resetPassword) {
      history.push("/forgotPassword");
    }
  }, [history, resetPassword]);

  const onSubmit: SubmitHandler<FormValues> = async (data) => {
    setPending(true);
   /*  if (!checked) { */
      TokenStorage.updateLoginTimer();
    /* } */

    const s = await auth.login(data.username, data.password).catch((_) => {});
    if (!s) {
      setError("Noget gik galt, brugte du de rigtige oplysninger?");
    }
    setPending(false);
  };

  const handleClose = () => {
    setError("");
  };

  const handleResetPassword = () => {
    setResetPassword(true);
  };
  
  return (
    <Grid container component="main" className={classes.root}>
      <CssBaseline />
      <Grid item xs={false} sm={4} md={7} className={classes.image} />
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <div className={classes.paper}>
          {/* <Avatar className={classes.logo}>
            <LockOutlinedIcon />
          </Avatar> */}
          <Typography component="h1" variant="h5">
            {/* Parking Solvisions webportal */}
            Dopagos Webportal
          </Typography>
          <form
            className={classes.form}
            noValidate
            onSubmit={handleSubmit(onSubmit)}
          >
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="username"
              label="Brugernavn"
              name="username"
              autoComplete="username"
              autoFocus
              inputRef={register({
                required: true,
              })}
              error={errors.username ? true : false}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label="Kodeord"
              type="password"
              id="password"
              autoComplete="current-password"
              inputRef={register({
                required: true,
              })}
              error={errors.password ? true : false}
            />
          {/*   <Box style={{ display: "flex", alignItems: "center" }}>
              <Checkbox
                checked={checked}
                onClick={() => {
                  setChecked(!checked);
                }}
                color="primary"
              />
              <Typography variant="body2" style={{ display: "inline-block" }}>
                Husk mig
              </Typography>
            </Box> */}

            <LoadingButton
              pending={pending}
              text={"Log ind"}
              update={() => {}}
            />
            {/* </div> */}
            <Grid container>
              <Grid item xs>
                <Link href="https://www.dopago.com/kontakt-os" variant="body2">
                  Opret Konto - Kontakt os
                </Link>
              </Grid>
              <Grid item xs style={{ textAlign: "right" }}>
                <Link
                  onClick={handleResetPassword}
                  variant="body2"
                  style={{ cursor: "pointer" }}
                >
                  Nulstil kodeord
                </Link>
              </Grid>
              {/* <Grid item>
                <Link href="https://www.parkingsolvision.com/kontakt/kontakt" variant="body2">
                  {"Ingen konto? Kontakt os"}
                </Link>
              </Grid> */}
            </Grid>
            <Box mt={5}>
              <Copyright />
            </Box>
          </form>
        </div>
      </Grid>
      <Dialog
        open={!!error}
        //onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Log ind fejlet"}</DialogTitle>
        <DialogContent>
          {error && (
            <DialogContentText id="alert-dialog-description">
              <Error />
              {error ? error : ""}
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            Luk
          </Button>
        </DialogActions>
      </Dialog>
      <NoDataDialog
        open={open}
        onClose={() => setOpen(false)}
        title={"!!! DETTE ER ET TEST BUILD !!!"}
        text={"Er du det rigtige sted??"}
      />
    </Grid>
  );
};

export default Login;
